/**
 * Widths that keep a practice view's question area usable beside its side panels
 * (the notes panel, a docked calculator). The numbers drive layout decisions; each
 * class enforces its number, and must be literal text for Tailwind to generate it.
 */

/** Narrowest either half of the side-by-side question/answer split may get. */
export const PANE_MIN_WIDTH = 280;

/**
 * Narrowest question area that fits the split: both panes, plus 16px for the split
 * wrapper's side padding below 780px, or for a classic vertical scrollbar above it.
 */
export const SIDE_BY_SIDE_MIN_WIDTH = 2 * PANE_MIN_WIDTH + 16;

/** Narrowest the question area gets when stacked; past it the view scrolls sideways. */
export const QUESTION_AREA_MIN_WIDTH = 480;

export const SIDE_BY_SIDE_MIN_WIDTH_CLASS = 'min-w-[576px]';
export const QUESTION_AREA_MIN_WIDTH_CLASS = 'min-w-[480px]';

/** `.practice-view__main`'s page padding, 16px a side, wherever a floor applies. */
export const PRACTICE_MAIN_INLINE_PADDING = 32;

/**
 * PracticeView puts its floor on `.practice-view__main`, so each is the question
 * area's plus PRACTICE_MAIN_INLINE_PADDING.
 */
export const PRACTICE_MAIN_MIN_WIDTH_CLASS: Readonly<Record<number, string>> = {
  [QUESTION_AREA_MIN_WIDTH]: 'min-w-[512px]',
  [SIDE_BY_SIDE_MIN_WIDTH]: 'min-w-[608px]'
};

/** The questions list column, `$pv_questions-list-width` in practice-view-variables.scss. */
export const QUESTIONS_LIST_WIDTH = 360;

/** Narrowest the view gets with its list open: the list column plus the stacked question area. */
export const PRACTICE_VIEW_MIN_WIDTH =
  QUESTIONS_LIST_WIDTH + QUESTION_AREA_MIN_WIDTH + PRACTICE_MAIN_INLINE_PADDING;

/** The question area's floor for the chosen layout, and the class that enforces it. */
export interface QuestionAreaMin {
  /** 0 where no floor applies (mobile). */
  width: number;
  className: string;
}
